import React from "react";

const WhatWeDo = ({ data }) => {
    if (!data) return null;

    return (
        <section className="py-5 contact-section2">
            <div className="container">
                <div className="sec-title text-center">
                    <h2>{data.main_heading || "What We Do"}</h2>
                </div>

                <div className="row justify-content-center">
                    {/* Left Column – Activities Cards */}
                    <div className="col-md-7">
                        <div className="row g-4">
                            {data.items && data.items.map((item, index) => (
                                <div 
                                    className={`col-md-${index === data.items.length - 1 ? '12' : '6'}`} 
                                    key={index}
                                >
                                    <div className="what-card">
                                        <div className="what-we-do-strip">{item.main_heading}</div>
                                        <div className="icon-box">
                                            <i className={`fa ${item.icon || 'fa-user'}`}></i>
                                        </div>
                                        <h5>{item.heading}</h5>
                                        <div dangerouslySetInnerHTML={{ __html: item.text }} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Column – Why Enroll With Us */}
                    <div className="col-md-5 d-flex align-items-center mt-5 mt-md-0">
                        <div
                            className="enroll-card p-4 rounded shadow-lg w-100"
                            style={{ background: "#ffffffcc", backdropFilter: "blur(6px)" }}
                        >
                            <h3 className="fw-bold mb-3">Why Enroll With Us?</h3>
                            <ul className="text-dark" style={{ listStyleType: "none"}}>
                                {data.main_list && data.main_list.map((point, index) => (
                                    <li className="mb-2" key={index}>
                                        <i className="fa fa-dot-circle-o me-2" style={{ color: "var(--thm-bg)" }}
></i>
                                        {point}
                                    </li>
                                ))}
                            </ul>
                            <p className="fw-semibold text-success mt-3">
                                {data.main_input || "Enroll with us, realize your dream and make a difference in your career."}
                            </p>

                            {data.main_image && (
                                <img
                                    src={data.main_image}
                                    alt="Apply"
                                    className="img-fluid mt-3 rounded"
                                    onError={(e) => {
                                        e.target.src = "https://via.placeholder.com/400x200?text=No+Image";
                                    }}
                                    style={{ borderRadius: '10px' }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhatWeDo;